import axios from "axios";
import { IFxRates } from "./fxRates";

export const getChartData = async (chartData: IFxRates.IFxRatesProps) => {
  return await axios.get(
    `${process.env.REACT_APP_FIXER_ID}/api/timeseries?access_key=${process.env.REACT_APP_ACCESS_KEY}&base=INR&symbols=${chartData.symbolsString}&start_date=${chartData.startDate}&end_date=${chartData.endDate}`
  );
};
